import * as THREE from 'three';

export default class FloatingElements {
  constructor(experience) {
    this.experience = experience;
    this.scene = this.experience.scene;

    this.group = new THREE.Group();
    this.scene.add(this.group);

    this.setParticles();
    this.setFloatingShapes();
  }

  setParticles() {
    const count = 120;
    const geometry = new THREE.BufferGeometry();
    const positions = new Float32Array(count * 3);
    const scales = new Float32Array(count);

    for (let i = 0; i < count; i++) {
      const i3 = i * 3;
      // Scatter in a cylinder with deep 3D foreground and background depth
      const radius = 1.6 + Math.random() * 4.2;
      const angle = Math.random() * Math.PI * 2;

      positions[i3] = Math.cos(angle) * radius;
      positions[i3 + 1] = (Math.random() - 0.5) * 6.5;
      // Z spans both well in front of and behind the character (-4.0 to +3.5)
      positions[i3 + 2] = (Math.random() - 0.5) * 7.5;

      scales[i] = Math.random() * 0.85 + 0.2;
    }

    geometry.setAttribute('position', new THREE.BufferAttribute(positions, 3));

    const material = new THREE.PointsMaterial({
      color: new THREE.Color('#38bdf8'),
      size: 0.05,
      transparent: true,
      opacity: 0.6,
      blending: THREE.NormalBlending
    });

    this.points = new THREE.Points(geometry, material);
    this.group.add(this.points);
  }

  setFloatingShapes() {
    this.floatingMeshes = [];
    const shapeCount = 8;
    const geo = new THREE.IcosahedronGeometry(0.14, 0);

    const mat = new THREE.MeshPhysicalMaterial({
      color: '#93c5fd',
      roughness: 0.15,
      transmission: 0.85,
      transparent: true,
      opacity: 0.85,
      clearcoat: 1
    });

    for (let i = 0; i < shapeCount; i++) {
      const mesh = new THREE.Mesh(geo, mat.clone());
      const angle = (i / shapeCount) * Math.PI * 2;
      const radius = 2.7 + (Math.random() - 0.5) * 0.8;

      mesh.position.set(
        Math.cos(angle) * radius,
        (Math.random() - 0.5) * 3.6,
        (Math.random() - 0.5) * 5.0 // Spans behind and in front of the patch plane
      );

      mesh.castShadow = true;
      this.group.add(mesh);

      this.floatingMeshes.push({
        mesh,
        baseY: mesh.position.y,
        speed: 0.5 + Math.random() * 0.5,
        offset: Math.random() * Math.PI * 2,
        rotSpeed: (Math.random() - 0.5) * 0.02
      });
    }
  }

  update(elapsed) {
    // Slowly rotate particle field
    if (this.points) {
      this.points.rotation.y = elapsed * 0.02;
    }

    // Bobbing floating geometric shapes
    this.floatingMeshes.forEach(item => {
      item.mesh.position.y = item.baseY + Math.sin(elapsed * item.speed + item.offset) * 0.15;
      item.mesh.rotation.x += item.rotSpeed;
      item.mesh.rotation.y += item.rotSpeed * 1.5;
    });

    // Parallax response to mouse
    if (this.experience.mouse) {
      this.group.position.x = -this.experience.mouse.current.x * 0.2;
      this.group.position.y = -this.experience.mouse.current.y * 0.15;
    }
  }
}
